import React, { useEffect, useState } from 'react';
import styles from './RaffleModal.module.scss';
import Modal from '../Modal/Modal';
import { TelegramSticker } from '@/components/TelegramSticker';
import WebApp from '@twa-dev/sdk';

interface RaffleModalProps {
  open: boolean;
  onClose: () => void;
}

const RaffleModal: React.FC<RaffleModalProps> = ({ open, onClose }) => {
  if (!open) return null;

  const handleParticipate = async () => {
    // Добавляем вибрацию при нажатии на кнопку
    if (WebApp && WebApp.HapticFeedback) {
      WebApp.HapticFeedback.notificationOccurred('success');
    } else {
      console.warn('Telegram WebApp or HapticFeedback is not available');
    }
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <h2 className={styles.title}>Розыгрыши скоро будут доступны!</h2>
        <div className={styles.stickerWrapper}>
          <TelegramSticker
            tgsUrl="./slots.tgs"
            style={{ width: 160, height: 160 }}
            loop={false}
            autoplay={true}
          />
        </div>

        <p className={styles.description}>
          Мы готовим для тебя возможность участвовать <br /> в крутых розыгрышах
          и получать подарки.
          <br />
          Оставайся с нами — скоро станет доступно!
        </p>
        <button className={styles.withdrawButton} onClick={handleParticipate}>
          Окей, жду!
        </button>
      </div>
    </Modal>
  );
};

export default RaffleModal;
